import puiHotModuleLayout from '../layouts/HotModuleLayout';
import puiCommonMessageBox from './alerts/MessageBox';
import puiAttributeDetailPanel from './attributes/AttributeDetailPanel.vue';
import puiAttributeExternalLink from './attributes/AttributeExternalLink.vue';
import puiAttributeFilterPanel from './attributes/AttributeFilterPanel.vue';
import puiAttributeGroupPanel from './attributes/AttributeGroupPanel.vue';
import puiAttributePanel from './attributes/AttributePanel.vue';
import puiAttributeTable from './attributes/AttributeTable.vue';
import puiAttributeTree from './attributes/AttributeTree.vue';
import puiMultipleAttributePanel from './attributes/MultipleAttributePanel.vue';
import puiUnsavedAttributesDialog from './attributes/UnsavedAttributesDialog';
import puiBallLoader from './BallLoader';
import puiBigPreview from './BigPreview';
import puiError from './Error';
import puiCommonDropZone from './overrides/dragNDrop/DropZone';
import puiCommonDropZoneWithPreview from './overrides/dragNDrop/DropZoneWithPreview';
import puiCommonInputTag from './overrides/forms/InputTag';
import puiCommonSelect from './overrides/forms/Select';
import puiCommonProgressLinear from './overrides/progress/ProgressLinear';
import puiCommonSpinner from './overrides/progress/Spinner';
import puiCorruptedThumbnail from './thumbnail/CorruptedThumbnail.vue';
import puiFileThumbnailViewer from './thumbnail/FileThumbnailViewer.vue';
import puiThumbnail from './thumbnail/Thumbnail.vue';
import puiThumbnailAction from './thumbnail/ThumbnailAction.vue';
import puiThumbnailMainAction from './thumbnail/ThumbnailMainAction.vue';
import puiFileUploadDialog from './upload/FileUploadDialog';

export {
  puiAttributeGroupPanel,
  puiMultipleAttributePanel,
  puiAttributePanel,
  puiAttributeFilterPanel,
  puiAttributeDetailPanel,
  puiCommonDropZone,
  puiCommonDropZoneWithPreview,
  puiCommonInputTag,
  puiAttributeTable,
  puiAttributeTree,
  puiAttributeExternalLink,
  puiCommonSelect,
  puiCommonProgressLinear,
  puiCommonSpinner,
  puiCommonMessageBox,
  puiHotModuleLayout,
  puiFileThumbnailViewer,
  puiCorruptedThumbnail,
  puiThumbnail,
  puiThumbnailMainAction,
  puiThumbnailAction,
  puiBigPreview,
  puiUnsavedAttributesDialog,
  puiError,
  puiFileUploadDialog,
  puiBallLoader,
};

export const components = [
  puiAttributeGroupPanel,
  puiMultipleAttributePanel,
  puiAttributePanel,
  puiAttributeFilterPanel,
  puiAttributeDetailPanel,
  puiAttributeTable,
  puiAttributeTree,
  puiAttributeExternalLink,
  puiCommonDropZone,
  puiCommonDropZoneWithPreview,
  puiCommonSelect,
  puiCommonInputTag,
  puiCommonProgressLinear,
  puiCommonSpinner,
  puiCommonMessageBox,
  puiHotModuleLayout,
  puiFileThumbnailViewer,
  puiCorruptedThumbnail,
  puiThumbnail,
  puiThumbnailMainAction,
  puiThumbnailAction,
  puiBigPreview,
  puiUnsavedAttributesDialog,
  puiError,
  puiFileUploadDialog,
  puiBallLoader,
];
